module.exports = __webpack_public_path__ + "img/purim-2018-thumbnail.7639f049.jpeg";